import styled from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"

type MIndicatorProps = {
  children: React.ReactNode
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning"
  variant?: "dot" | "standard"
  content?: React.ReactNode
  overlap?: boolean
  invisible?: boolean
}

export function MIndicator({
  children,
  color = "primary",
  variant = "standard",
  content,
  invisible = false,
}: MIndicatorProps) {
  return (
    <IndicatorRoot>
      {children}
      {!invisible && !!content && (
        <Badge $color={color} $variant={variant}>
          {variant === "standard" && content}
        </Badge>
      )}
    </IndicatorRoot>
  )
}

const IndicatorRoot = styled.div`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  flex-shrink: 0;
`

const Badge = styled.span<{
  $color: MIndicatorProps["color"]
  $variant: MIndicatorProps["variant"]
}>`
  display: flex;
  flex-flow: row wrap;
  place-content: center;
  align-items: center;
  position: absolute;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 0.75rem;
  min-width: 20px;
  height: 20px;
  border-radius: 9999px;
  z-index: 1;
  background-color: ${colors.textPrimary};
  color: ${colors.textContrast};
  top: 0;
  right: ${spacing.XS};
  transform: translateY(-30%);

  ${(props) =>
    props.$variant === "dot" &&
    `
    height: 6px;
    padding: 0;
    width: 6px;
    min-width: 6px;
    border-radius: 3px;
  `}
`
